module.exports = __webpack_public_path__ + "static/passive-64bfe041a82e3f6ea7df48c97d34f5d0.mp4";